import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Plot from "../pages/plot/page";
import Characters from "../pages/characters/page";
import Chapters from "../pages/chapters/page";
import ChapterDetail from "../pages/chapters/detail";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/plot",
    element: <Plot />,
  },
  {
    path: "/characters",
    element: <Characters />,
  },
  {
    path: "/chapters",
    element: <Chapters />,
  },
  {
    path: "/chapters/:id",
    element: <ChapterDetail />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;